import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import { GlobalDataHandler } from './shared/GlobalDataHandler';
import { MixpanelService } from './core/services/mixpanel/mixpanel.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'MFG.com';

  constructor(
    private router: Router,
    private mixpanelService: MixpanelService
  ) { }

  ngOnInit() {
    this.mixpanelService.init();
    this.mixpanelService.restoreIdentityFromStorage();
    // let data = sessionStorage.getItem('randomNumber');
    // if(data == null || data ==undefined || data =='' ) {
    //   localStorage.clear();
    //   sessionStorage.clear();
    //   this.router.navigate(['auth/login/simple']);
    // }
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
      const path = evt.urlAfterRedirects || evt.url;
      this.mixpanelService.trackPageView(path);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts